import { ObjectValues } from 'types/object-values';

export const ENVELOPE_TYPE = {
  NDA: 'nda',
  W9: 'w-9',
  W8BEN: 'w-8ben',
} as const;

export type EnvelopeType = ObjectValues<typeof ENVELOPE_TYPE>;
